<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <create-roles>
        </create-roles> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import createRoles from './todo-create-roles'
export default {
    components: {
        createRoles
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-user-roles/base-create-roles.vue